import {Component} from '@angular/core';
import {ModalRef} from '../modal-ref';

@Component({
    selector: 'app-message-box',
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.css'],
    standalone: false
})
export class MessageBoxComponent {
    title = '';
    text = '';
    image = '';

    constructor(private modal: ModalRef) {
        this.title = modal.data.title;
        this.text = modal.data.text;
        this.image = modal.data.image;
    }

    ok(): void {
        this.modal.close();
    }
}
